export default __webpack_public_path__ + "static/media/batteraside3.52e02fab.png";